import { render } from "./Login_start.vue?vue&type=template&id=4a0f1915&scoped=true"
import script from "./Login_start.vue?vue&type=script&lang=js"
export * from "./Login_start.vue?vue&type=script&lang=js"

import "./Login_start.vue?vue&type=style&index=0&id=4a0f1915&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0f1915"]])

export default __exports__